"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SkeletonLine_1 = __importDefault(require("./SkeletonLine"));
const SkeletonWrapper = ({ children, Skeleton = react_1.default.createElement(SkeletonLine_1.default, null), isLoading, }) => {
    if (isLoading)
        return Skeleton;
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.default = SkeletonWrapper;
//# sourceMappingURL=SkeletonWrapper.js.map